import { TransportSedel } from "types/transportSedel.type";
import { Waste } from "types/waste.type";

export type LoadingRequirementKey =
  | "wasteStation"
  | "vehicle"
  | "timeOfDeparture"
  | "wasteWeight"
  | "driverSignature"
  | "customerSignature";

export type CompletionRequirementKey = "wasteStationSignature" | "finalWeight";

export type RequirementKey = LoadingRequirementKey | CompletionRequirementKey;

export type SignatureRequirementKey = Extract<
  RequirementKey,
  "driverSignature" | "customerSignature" | "wasteStationSignature"
>;

export type Requirement = {
  key: RequirementKey;
  label: string;
  isFulfilled: boolean;
};

const isPositiveNumber = (value?: string | number | null): boolean => {
  if (value === null || value === undefined) return false;
  const parsed =
    typeof value === "number" ? value : Number(value.trim().replace(",", "."));
  return Number.isFinite(parsed) && parsed > 0;
};

export const wasteHasWeight = (waste: Waste): boolean =>
  isPositiveNumber(waste.weightPreliminary) ||
  isPositiveNumber(waste.weightFinal);

export const wasteHasFinalWeight = (waste: Waste): boolean =>
  isPositiveNumber(waste.weightFinal);

export const hasWasteWithWeight = (transportSedel: TransportSedel): boolean =>
  transportSedel.wasteList.some(wasteHasWeight);

// TODO: Platshållare – den riktiga logiken för vad som krävs innan lastning
// kommer senare. Byt ut innehållet här, UI:t läser bara listan.
export const getLoadingRequirements = (
  transportSedel: TransportSedel,
): Requirement[] => [
  {
    key: "wasteStation",
    label: "Mottagarstation",
    isFulfilled: !!transportSedel.wasteStation,
  },
  {
    key: "vehicle",
    label: "Fordon",
    isFulfilled: !!transportSedel.vehicle,
  },
  {
    key: "timeOfDeparture",
    label: "Datum för avfärd",
    isFulfilled: !!transportSedel.timeOfDepartureUtc,
  },
  {
    key: "wasteWeight",
    label: "Minst ett avfall med vikt",
    isFulfilled: hasWasteWithWeight(transportSedel),
  },
  {
    key: "driverSignature",
    label: "Signatur chaufför",
    isFulfilled: !!transportSedel.driverSignature,
  },
  {
    key: "customerSignature",
    label: "Signatur lämnare",
    isFulfilled:
      !!transportSedel.customerSignature ||
      transportSedel.customerSignatureUnavailable,
  },
];

// TODO: Platshållare även här – byts ut mot den riktiga logiken senare.
export const getCompletionRequirements = (
  transportSedel: TransportSedel,
): Requirement[] => [
  {
    key: "wasteStationSignature",
    label: "Signatur mottagare",
    isFulfilled:
      !!transportSedel.wasteStationSignature ||
      transportSedel.wasteStationSignatureUnavailable,
  },
  {
    key: "finalWeight",
    label: "Vägd vikt på alla avfall",
    isFulfilled:
      transportSedel.wasteList.length > 0 &&
      transportSedel.wasteList.every(wasteHasFinalWeight),
  },
];
